import { TeamAccessDTO } from '../team/team-access.dto';
import { UserListDTO } from '../user/user-list.dto';

export class WikiPostListDTO extends TeamAccessDTO {

    title: string;

    views: number;

    author: UserListDTO;
    
}
